import styled from "styled-components";

export const PedidosContainer = styled.div`
  margin-top: 15px;
  background-color: #F4F5F5;
`;
export const PedidosContainerText = styled.div`
  font-family: Akrobat;
  background-color: #87a894;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const GenerateOrderContent = styled.div`
  width: 1368px;
  min-height: 300px;
  height: auto;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  background-color: white;  
`;
export const GenerateFindRequest = styled.div`
  width: 100%;
  height: 100px;
  position: relative;
`;
export const GenerateFindRequestResume = styled.div`
  display: flex;
  width: 100%;
  min-width: 1200px;
  max-width: 1340px;
  padding: 0px 0px;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
`;
export const GenerateFindRequestResumeLoading = styled.div`
  width: 100%;
  height: 600px;
  position: absolute;
  background-color: #F4F5F5;
  align-items: center;
  z-index: 9999;

  .product {
    height: 100%;
  }
  .resumo {
    height: 100vh;
  }
  .modal {
    width: 990px;
  }

  .historic {
    width: 1120px;
  }

  .orcamento {
    width: 100%;
    height: 700px;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
  }

  .resumo {
    height: 800px;
  }
`;
export const GenerateFindRequestResumeLoadingContent = styled.div`
  width: 100px;
  height: 100%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  img {
    width: 100px;
    height: 100px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
`;
export const GenerateFindRequestResumeContent = styled.div`
  width: 98%;
`;
export const GenerateFindRequestResumeContentFilter = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  margin: 40px 0;
  font-size: 18px;
  color: #80bd01;
`;
export const GenerateFindRequestResumeContentFilterSelector = styled.div`
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0 5px;
  font-family: Akrobat;
  font-size: 15px;
  margin: 0 10px;
  display: flex;
  align-items: center;

`;
export const GenerateFindRequestResumeContentFilterSelectorButton = styled.button`
  padding: 0 13px;
  height: 37px;
  background-color: #ff7e00;
  color: white;
  font-family: Akrobat;
  border-radius: 5px;
  margin-top: 0.1rem;
`;
export const GenerateFindRequestResumeSubtext = styled.div`
  height: 20px;
  width: 98%;
  position: relative;
  top: -40px;
  h1 {
    font-family: "Akrobat SemiBold";
    font-size: 18px;
    color: rgb(61, 61, 61);
    text-align: center;
  }
`;
